'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Key = require('common/domain/value/key');
const Actions = require('common/domain/action/index');
const ProjectModel = require('common/domain/entity/project');
const Dispatcher = require('common/domain/repository/dispatcher');
const GroupRepository = require('common/domain/repository/group');
const GroupRoleRepository = require('common/domain/repository/group-role');
const ProjectRoleRepository = require('common/domain/repository/project-role');
const ProjectRepository = require('common/domain/repository/project');
const ProjectStatusFactory = require('common/domain/factory/project-status/index');
const ProjectStatusRepository = require('common/domain/repository/project-status');
const DiagramRepository = require('system/domain/repository/diagram');
const ActionRepository = require('process/domain/repository/action/index');
const ActionFactory = require('process/domain/factory/action/index');
const CommentRepository = require('communication/domain/repository/comment');
const CommentFactory = require('communication/domain/factory/comment');
const TaskRepository = require('communication/domain/repository/task');
const TaskFactory = require('communication/domain/factory/task');
const ContentActionWorkRepository = require('balus/infra/repository/actionwork/content');
const DiagramActionWorkRepository = require('balus/infra/repository/actionwork/diagram');
const ContentFactory = require('data/domain/factory/content/index');
const ContentRepository = require('data/domain/repository/content/index');
const Router = require('balus/app/router/index');
const Context = require('common/domain/value/context');
const DataPermission = require('data/domain/entity/permission');
const Logger = require('common/util/logger');
const ProcessPermission = require('process/domain/entity/permission');
const ActionContext = require('process/domain/value/context');

/**
 * 同時編集関連の Module
 */
module.exports = Backbone.Model.extend({
    initialize: function(applicationContext, channel) {
        this._applicationContext = applicationContext;
        this._channel = channel;

        this.listenTo(channel, 'msg:dataset:diagram:add', this.addDiagram);
        this.listenTo(channel, 'msg:dataset:diagram:update', this.updateDiagram);
        this.listenTo(channel, 'msg:dataset:diagram:delete', this.deleteDiagram);
        this.listenTo(channel, 'msg:elements:update', this.updateElements);
        this.listenTo(channel, 'msg:comment:create', this.createComment);
        this.listenTo(channel, 'msg:comment:reaction:add', this.addCommentReaction);
        this.listenTo(channel, 'msg:comment:reaction:remove', this.removeCommentReaction);
        this.listenTo(channel, 'msg:tag:create', this.createTag);
        this.listenTo(channel, 'msg:tag:update', this.updateTag);
        this.listenTo(channel, 'msg:tag:delete', this.deleteTag);
        this.listenTo(channel, 'msg:tag-category:create', this.createTagCategory);
        this.listenTo(channel, 'msg:tag-category:update', this.updateTagCategory);
        this.listenTo(channel, 'msg:tag-category:delete', this.deleteTagCategory);
        this.listenTo(channel, 'msg:commit:create', this.createCommit);
        this.listenTo(channel, 'msg:project-status:update', this.updateProjectStatus);
        this.listenTo(channel, 'msg:project-status:delete', this.deleteProjectStatus);
        this.listenTo(channel, 'msg:project:update', this.updateProject);
        this.listenTo(channel, 'msg:project:delete', this.deleteProject);
        this.listenTo(channel, 'msg:action:create', this.createAction);
        this.listenTo(channel, 'msg:action:update', this.updateAction);
        this.listenTo(channel, 'msg:action:delete', this.deleteAction);
        this.listenTo(channel, 'msg:data:content:create', this.createContent);
        this.listenTo(channel, 'msg:data:content:update', this.updateContent);
        this.listenTo(channel, 'msg:data:content:delete', this.deleteContent);
        this.listenTo(channel, 'msg:action:content-work:create', this.createContentActionWork);
        this.listenTo(channel, 'msg:action:content-work:update:relation', this.updateContentActionWorkRelation);
        this.listenTo(channel, 'msg:action:content-work:delete', this.deleteContentActionWork);
        this.listenTo(channel, 'msg:action:diagram-work:create', this.createDiagramActionWork);
        this.listenTo(channel, 'msg:action:diagram-work:update:relation', this.updateDiagramActionWorkRelation);
        this.listenTo(channel, 'msg:action:diagram-work:delete', this.deleteDiagramActionWork);
        this.listenTo(channel, 'msg:task:create', this.createTask);
        this.listenTo(channel, 'msg:task:update', this.updateTask);
    },

    _buildProjectContext: function (context) {
        const appInfo = this._applicationContext.getAppInfo();
        const user = this._applicationContext.getUser();
        const project = ProjectRepository.getProjects().get(context.projectId);
        const group = GroupRepository.getGroups().get(project.getGroupId());
        const groupMember = group.getMembers().getMemberByUser(user);
        const groupRoleID = groupMember ? groupMember.getRole() : 'anonymous';
        const groupRole = GroupRoleRepository.find(group).getRoles().get(groupRoleID);
        const projectMember = project.getMembers().getMemberByUser(user);
        const projectRoleID = projectMember ? projectMember.getRole() : 'anonymous';
        const projectRole = ProjectRoleRepository.find(group).getRoles().get(projectRoleID);
        return new Context.ProjectContext(appInfo, user, group, groupRole, project, projectRole);
    },

    addDiagram: function(data, context) {
        const diagram = DiagramRepository.getDiagrams({
            context: context
        }).get(data.diagram.id);
        if(diagram) {
            return;
        }

        Dispatcher.dispatch({
            type: Actions.CREATE_DIAGRAM,
            context: context,
            diagram: data.diagram
        });
    },

    updateDiagram: function(data, context) {
        const diagram = DiagramRepository.getDiagrams({
            context: context
        }).get(data.diagram.id);
        if(!diagram) {
            return;
        }

        Dispatcher.dispatch({
            type: Actions.UPDATE_DIAGRAM,
            context: context,
            diagram: data.diagram
        });
    },

    deleteDiagram: function(data, context) {
        const diagram = DiagramRepository.getDiagrams({
            context: context
        }).get(data.diagram.id);
        if(!diagram) {
            return;
        }

        Dispatcher.dispatch({
            type: Actions.DELETE_DIAGRAM,
            context: context,
            diagram: data.diagram
        });

        const currentAddress = location.href;
        if(currentAddress.match(/diagrams\//g)){
            Router.navigateDiagramDashboard(context.projectId);
        }
    },

    updateElements: function(data, context) {
        // Node model
        if(data.models && data.models.records) {
            Dispatcher.dispatch({
                type: Actions.MERGE_NODE,
                context: context,
                node: data.models.records
            });
        }

        // Link model
        if(data.models && data.models.relations) {
            Dispatcher.dispatch({
                type: Actions.MERGE_LINK,
                context: context,
                link: data.models.relations
            });
        }

        const diagram = DiagramRepository.getDiagrams({
            context: context
        }).get(data.diagram.id);

        if(!diagram) {
            return
        }

        context.diagramId = diagram.id;

        // Node meta
        if(data.metas && data.metas.records) {
            Dispatcher.dispatch({
                type: Actions.MERGE_NODE_META,
                context: context,
                nodeMeta: _.map(data.metas.records, function (j, uid) {
                    j.id = uid;
                    return j;
                })
            });
        }

        // Link meta
        if(data.metas && data.metas.relations) {
            Dispatcher.dispatch({
                type: Actions.MERGE_LINK_META,
                context: context,
                linkMeta: _.map(data.metas.relations, function (j, uid) {
                    j.id = uid;
                    return j;
                })
            });
        }

        Dispatcher.dispatch({
            type: Actions.UPDATE_DIAGRAM,
            context: context,
            diagram: data.diagram
        });
    },

    createComment: function(commentJSON, context) {
        const projectContext = this._buildProjectContext(context);
        const project = projectContext.getProject();
        const projectRole = projectContext.getProjectRole();
        const factory = new CommentFactory(project);
        const repo = CommentRepository.find(project);
        const actionRepository = ActionRepository.find(project);

        factory.build(commentJSON)
            .then(comment => {
                // コラボレータ権限の場合には、コメント relatedKeys に設定された Action にアクセスできる場合に限定する。
                if (projectRole.id === 'collaborator') {
                    const relatedActionKeys = comment.getRelatedKeys().filter((key) => key.kind === 'Action');
                    const actionIds = relatedActionKeys.map((key) => key.id);
                    const found = actionIds.find((actionId) => actionRepository.getFromCache(actionId));
                    if (!found) {
                        Logger.info(`ConcurrentEdit#createComment: skipped (commentId=${comment.id})`)
                        return;
                    }
                }

                repo.add(comment, {addCount: true});
                // コメントの追加に成功した後に snackbar 通知用に再度イベントを発火する
                this._channel.trigger('msg:comment:create:notify', commentJSON, context);
            });
    },

    addCommentReaction: function(reactionJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        const repo = CommentRepository.find(project);
        const comment = repo.get(context.commentId);

        const reactionName = reactionJSON.reactionName;
        const userKey = new Key(reactionJSON.userKey);
        const actionAt = reactionJSON.actionAt;

        if (comment) {
            comment.addReaction(reactionName, userKey, actionAt);
        }
    },

    removeCommentReaction: function(reactionJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        const repo = CommentRepository.find(project);
        const comment = repo.get(context.commentId);

        const reactionName = reactionJSON.reactionName;
        const userKey = new Key(reactionJSON.userKey);

        if (comment) {
            comment.removeReaction(reactionName, userKey);
        }
    },

    updateProjectStatus: function(projectStatusJSON, context) {
        const group = GroupRepository.getGroups().get(context.groupId);
        const repository = ProjectStatusRepository.find(group);

        const factory = new ProjectStatusFactory();
        factory.build(projectStatusJSON)
            .then(projectStatus => {
                repository.add([projectStatus]);
            });
    },

    deleteProjectStatus: function(projectStatusJSON, context) {
        const group = GroupRepository.getGroups().get(context.groupId);
        const repository = ProjectStatusRepository.find(group);

        const factory = new ProjectStatusFactory();
        factory.build(projectStatusJSON)
            .then(projectStatus => {
                repository.delete([projectStatus]);
            });
    },

    updateProject: function(projectJSON) { // context は不要なので省略
        const project = new ProjectModel(projectJSON);
        ProjectRepository.add(project);
    },

    deleteProject: function(projectJSON, context) {
        ProjectRepository.remove(context.projectId);
    },

    createAction: function(actionJSON, context) {
        const projectContext = this._buildProjectContext(context);
        const project = projectContext.getProject();

        const factory = new ActionFactory(project);
        const repo = ActionRepository.find(project);
        const isHistory = false;
        const appendChild = false;

        const factoryPromise = factory.build(actionJSON, repo, isHistory, appendChild);
        const parentPromise = actionJSON.parent ? repo.fetchActionNoRaise(actionJSON.parent) : null;

        Promise.all([factoryPromise, parentPromise]).then((values) => {
            const action = values[0];
            const parentAction = values[1];
            // 対象アクション or 親アクションが見つからない場合には、追加しない
            if (!action || !parentAction) {
                Logger.info(`ConcurrentEdit#createAction skipped (key=${actionJSON.key})`);
                return;
            }

            const actionContext = ActionContext.build(projectContext, action)

            // 対象の Action に対する閲覧権限が無いので、 repository への追加処理をスキップする
            const permission = actionContext.getProjectRole().getPermission(ProcessPermission.ActionViewPermission);
            if (!permission.isPermitted(actionContext)) {
                Logger.info(`ConcurrentEdit#createAction permission denied (key=${actionJSON.key})`);
                return;
            }

            parentAction.addChild(action);
            action.set('parent', parentAction);

            repo.add(action);
            Logger.info(`ConcurrentEdit#createAction action added (${action.key})`);
        })
    },

    updateAction: function(actionJSON, context) {
        const projectContext = this._buildProjectContext(context);
        const project = projectContext.getProject();
        const factory = new ActionFactory(project);
        const repo = ActionRepository.find(project);
        const isHistory = false;
        const appendChild = false;

        const oldAction = repo.getFromCache(actionJSON.id);
        const factoryPromise = factory.build(actionJSON, repo, isHistory, appendChild);
        const parentPromise = actionJSON.parent ? repo.fetchActionNoRaise(actionJSON.parent) : null;

        Promise.all([factoryPromise, parentPromise]).then((values) => {
            const action = values[0];
            const parentAction = values[1];
            // 対象アクション or 親アクションが見つからない場合には、追加しない
            if (!action || !parentAction) {
                Logger.info(`ConcurrentEdit#updateAction skipped (key=${actionJSON.key})`);
                return;
            }

            const actionContext = ActionContext.build(projectContext, action)

            // 対象の Action に対する閲覧権限が無いので、 parent と repository から削除する
            const permission = actionContext.getProjectRole().getPermission(ProcessPermission.ActionViewPermission);
            if (!permission.isPermitted(actionContext)) {
                parentAction.removeChild(action);
                repo.remove(action);
                Logger.info(`ConcurrentEdit#updateAction action removed (key=${actionJSON.key})`);
                return;
            }

            if (oldAction && oldAction.getParent()) {
                const oldParentAction = oldAction.getParent();
                if (oldParentAction.get('id') !== parentAction.get('id')) {
                    oldParentAction.removeChild(oldAction);
                }
            }

            parentAction.addChild(action);
            action.set('parent', parentAction);

            repo.add(action);
            Logger.info(`ConcurrentEdit#updateAction action added (${action.key})`);
        })
    },

    deleteAction: function(actionJSON, context) {
        this.createAction(actionJSON, context);
    },

    /*
        FIX ME:
        5件以上存在しているところにモデルを追加すると正しく同期されない
        ただこの問題の修正はUI部分を含めて実施したい
        詳しくは https://github.com/levii/balus/pull/3305#discussion_r348927388
    */

    createContent: function(contentJSON, context) {
        const projectContext = this._buildProjectContext(context);
        const project = projectContext.getProject();

        // 対象の DataContent に対する閲覧権限が無いので、 repository への追加処理をスキップする
        const permission = projectContext.getProjectRole().getPermission(DataPermission.DataContentViewPermission);
        if (!permission.isPermitted(projectContext)) {
            Logger.info(`ConcurrentEdit#createContent permission denied (key=${contentJSON.key})`);
            return;
        }

        const repo = ContentRepository.find(project);
        const factory = new ContentFactory(project);

        factory.build(contentJSON)
            .then(content => {
                repo.add(content);
                Logger.info(`ConcurrentEdit#createContent content added (${content.key})`);
            });
    },

    updateContent: function(contentJSON, context) {
        this.createContent(contentJSON, context);
    },

    deleteContent: function(contentJSON, context) {
        this.createContent(contentJSON, context);
    },

    createContentActionWork: function(actionWorkJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        ActionRepository.find(project).fetchAction(project, context.actionId)
            .then((action) => {
                ContentActionWorkRepository.find(project)
                    .fetchActionWorksByAction(action, 5);
            });
    },

    deleteContentActionWork: function(actionWorkJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        ActionRepository.find(project).fetchAction(project, context.actionId)
            .then((action) => {
                const aw = ContentActionWorkRepository.find(project)
                    .getActionWorksByActionAndId(action, actionWorkJSON.id);
                ContentActionWorkRepository.find(project)
                    .getActionWorksByAction(action).remove(aw);
            });
    },

    updateContentActionWorkRelation: function(actionWorkJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        ActionRepository.find(project).fetchActionOnce(project, context.actionId)
            .then((action) => {
                const aw = ContentActionWorkRepository.find(project)
                    .getActionWorksByActionAndId(action, actionWorkJSON.id);
                aw.set({'relation': actionWorkJSON.relation});
            });
    },

    createDiagramActionWork: function(actionWorkJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        ActionRepository.find(project).fetchAction(project, context.actionId)
            .then((action) => {
                DiagramActionWorkRepository.find(project)
                    .fetchActionWorksByAction(action, 5);
            });
    },

    updateDiagramActionWorkRelation: function(actionWorkJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        ActionRepository.find(project).fetchActionOnce(project, context.actionId)
            .then((action) => {
                const aw = DiagramActionWorkRepository.find(project)
                    .getActionWorksByActionAndId(action, actionWorkJSON.id);
                aw.set({'relation': actionWorkJSON.relation});
            });
    },

    deleteDiagramActionWork: function(actionWorkJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        ActionRepository.find(project).fetchAction(project, context.actionId)
            .then((action) => {
                const aw = DiagramActionWorkRepository.find(project)
                    .getActionWorksByActionAndId(action, actionWorkJSON.id);
                DiagramActionWorkRepository.find(project)
                    .getActionWorksByAction(action).remove(aw);
            });
    },

    createTask: function(taskJSON, context) {
        const project = ProjectRepository.getProjects().get(context.projectId);
        const factory = new TaskFactory(project);
        const repo = TaskRepository.find(project);

        factory.build(taskJSON)
            .then(task => repo.add(task, {addCount: true}));
    },

    updateTask: function(taskJSON, context) {
        this.createTask(taskJSON, context);
    },

    createTag: function(tag, context) {
        Dispatcher.dispatch({
            type: Actions.CREATE_TAG,
            context: context,
            tag: tag
        });
    },

    updateTag: function(tag, context) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_TAG,
            context: context,
            tag: tag
        });
    },

    deleteTag: function(tag, context) {
        Dispatcher.dispatch({
            type: Actions.DELETE_TAG,
            context: context,
            tag: tag
        });
    },

    createTagCategory: function(category, context) {
        Dispatcher.dispatch({
            type: Actions.CREATE_TAG_CATEGORY,
            context: context,
            category: category
        });
    },

    updateTagCategory: function(category, context) {
        Dispatcher.dispatch({
            type: Actions.UPDATE_TAG_CATEGORY,
            context: context,
            category: category
        });
    },

    deleteTagCategory: function(category, context) {
        Dispatcher.dispatch({
            type: Actions.DELETE_TAG_CATEGORY,
            context: context,
            category: category
        });
    }

});



// WEBPACK FOOTER //
// ./balus/domain/service/concurrent-edit.js